// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/Tabs/Tabs.sass
// module id = 426
// module chunks = 0